import React from 'react';
import { withTranslation } from 'react-i18next';
import { Checkbox, Input } from 'semantic-ui-react';
import { formatCurrency } from '../../helpers/payDuties';

const PayForm = ({ inspection, parcelData, fields, onChangeInput, onChangeCheckbok, onClickButton, openForm, errors, t }) => {
  const { buyer, inspectionText, forms = [], isInspectionAlreadyPaid, isPaymentChargeless } = parcelData;
  const address = `${buyer.address.zip}, ${buyer.address.stAddress}, ${buyer.address.city}, ${buyer.address.country}`;
  const localCurrency = parcelData.duties.localCurrency;
  const amount = formatCurrency(localCurrency.payments.inspectionCommission[inspection], localCurrency.currencyCode);
  const { inspectionFeeTextNoPayment, inspectionFeeText } = inspectionText;
  const paidOrChageless = isInspectionAlreadyPaid || isPaymentChargeless;

  return (
    <div className='animated fadeIn'>
      <div className='section bold display-linebreak'>
        {paidOrChageless && inspectionFeeTextNoPayment ?
          t(inspectionFeeTextNoPayment) : t(inspectionFeeText, { amount })}
      </div>
      {!paidOrChageless ?
        <div className='section'>
          <div className='details'>
            <label>
              {t('amount')}
            </label>
            <div className='value bold'>
              {amount}
            </div>
          </div>
        </div>
        : '' }
      <div className='section'>
        <div className='title bold'>
          {t('recipientDetails')}
        </div>
        {buyer.isIDNeeded &&
          <div className='details'>
            <label htmlFor='id_number' className='red'>
              {t('id')}
            </label>
            <Input
              placeholder={t('enterId')}
              value={fields.buyerID || ''}
              name='buyerID'
              required={buyer.isIDNeeded}
              onChange={onChangeInput}
            />
          </div>}
        {errors.buyerID &&
          <div className='error-message animated fadeIn'>{errors.buyerID}
          </div>}
        <div className='details'>
          <label htmlFor='email' className='red'>
            {t('email')}
          </label>
          <Input
            placeholder={t('enterEmail')}
            value={fields.email || ''}
            name='email'
            required
            onChange={onChangeInput}
            type='email'
          />
        </div>
        {errors.email &&
          <div className='error-message animated fadeIn'>{errors.email}
          </div>}
        <div className='details'>
          <label>
            {t('name')}
          </label>
          <div className='value'>
            {buyer.name}
          </div>
        </div>
        <div className='details'>
          <label>
            {t('address')}
          </label>
          <div className='value'>
            {address}
          </div>
        </div>
      </div>
      <div className='section'>
        <div className='title bold'>
          {t('parcelDetails')}
        </div>
        <div className='details'>
          <label>
            {t('trackingNumber')}
          </label>
          <div className='value'>
            {parcelData.hawb}
          </div>
        </div>
        <div className='details'>
          <label>
            {t('parcelDescription')}
          </label>
          <div className='value'>
            {parcelData.description}
          </div>
        </div>
      </div>
      {forms.length > 0 && <div className='section'>
        <div className='title bold'>
          {t('forms')}
        </div>{
          forms.map((form, index) => {
            const { formName, formDescription, formRemarks = '', updateAt, filled } = form;
            const formUpdateAt = updateAt ? `${t('updateAt', { updateAt })}` : '';
            return (
              <div className='details'>
                <li key={index}>
                  <label className='listLabel'>
                    {formName}{`${formDescription ? ` - ${formDescription}` : ''}`}
                    {formUpdateAt && <br />}{formUpdateAt}{formRemarks && <br />}{formRemarks}
                  </label>
                </li>
                <div className='value centerBtn'>
                  <button className={filled ? 'formFilled' : 'form'} onClick={() => openForm(form)}>{filled ? t('updateForm') : t('fillForm')}</button>
                </div>
              </div>
            );
          })
        }</div>
      }
      {inspectionText.inspectionFeeTerms && !isPaymentChargeless &&
        <div className='section'>
          <div className='details'>
            { !isInspectionAlreadyPaid && 
              <Checkbox onChange={onChangeCheckbok} />
            }
            <button onClick={onClickButton} className='details'>
              { paidOrChageless ? t('acceptedTerms') : t('readAndAgree') }
            </button>
          </div>
        </div>
      }

    </div>
  );
};

export default withTranslation('payInspection')(PayForm);